import {createStore} from 'vuex'
import {breadcrumbType, userInfoType} from "@/type/ComponentDataType";
import createPersistedState from 'vuex-persistedstate'

export default createStore({
  strict: true, // process.env.NODE_ENV !== 'production',
  state: {
    isSidebarMinimized: false,
    token: "",
    refreshToken: "",
    Id: "",
    userID: "", //
    profilePicture: "",    // 用户头像
    userName: "",
    email: "",
    userRole: "",//角色
    alias: "",//角色
    isAdmin: "",//是否管理员
    otherRole:"",//其他角色，场景组，技术组，总部窗口，推进管理员
    rankType: "1",//排名类型 0 年 1 月
    jobZb: "",//总部
    jobName: "",//部门
    isPC:"",
    tabOptions: [],//tab选项
    classOptions: [],//分类选项
    searchData: {},//搜索条件
    searchDataRecord: {},
    forumPageData: { //面包屑
      sectionID: '',
      sectionName: '',
      labelID: '',
      labelName: '',
      pageIndex: 1,
      pageSize: 10,
      TimeSpan: '0',
      Order: '0'
    }

  },
  mutations: {
    updateSearchDataRecord(state, params) {
      state.searchDataRecord = params;
    },
    // updatePostsRouterParam(state,params){
    //   state.postsRouterParam = params;
    // },
    // clearPostsRouterParam(state,params){
    //   state.postsRouterParam = {};
    // },
    updateForumPageData(state, params: breadcrumbType) {
      state.forumPageData = params;
    },
    clearForumPageData(state) {
      state.forumPageData.sectionID = '';
      state.forumPageData.sectionName = '';
      state.forumPageData.labelID = '';
      state.forumPageData.labelName = '';
      state.forumPageData.pageIndex = 1;
      state.forumPageData.pageSize = 10;
      state.forumPageData.TimeSpan = '0';
      state.forumPageData.Order = '0';
    },
    updateSearchData(state, params) {
      state.searchData = params;
    },
    clearSearchData(state, params) {
      state.searchData = {};
    },
    updateTabOptions(state, params) {
      state.tabOptions = params;
    },
    updateClassOptions(state, params) {
      state.classOptions = params;
    },
    updateUserInfoAlias(state, params) {
      state.alias = params;
      localStorage.setItem("alias", params);
    },

    updateSidebarCollapsedState(state, isSidebarMinimized) {
      state.isSidebarMinimized = isSidebarMinimized
    },
    updateUserInfoProfilePicture(state, params) {
      state.profilePicture = params;
      localStorage.setItem("profilePicture", params);
    },
    // 更新用户信息
    updateUserInfo(state, userObj: userInfoType) {
      state.token = userObj.token;
      state.profilePicture = userObj.profilePicture;
      state.userID = userObj.userID;
      state.userName = userObj.userName;
      state.email = userObj.email;
      state.userRole = userObj.userRole;
      state.isAdmin = userObj.isAdmin;
      state.otherRole = userObj.otherRole;
      state.jobZb = userObj.jobZb;
      state.jobName = userObj.jobName;
      state.Id = userObj.Id;
      state.isPC = userObj.isPC;
      localStorage.setItem("token", userObj.token);
      localStorage.setItem("profilePicture", userObj.profilePicture);
      localStorage.setItem("userID", userObj.userID);
      localStorage.setItem("Id", userObj.Id);
      localStorage.setItem("userName", userObj.userName);
      localStorage.setItem("email", userObj.email);
      localStorage.setItem("userRole", userObj.userRole);
      localStorage.setItem("isAdmin", userObj.isAdmin);
      localStorage.setItem("otherRole", userObj.otherRole);
      localStorage.setItem("jobZb", userObj.jobZb);
      localStorage.setItem("jobName", userObj.jobName);
      localStorage.setItem("isPC", userObj.isPC);
    },
    logoutUserInfo(state) {
      state.token = "";
      state.profilePicture = "";
      state.userID = "";
      state.Id = "";
      state.userName = "";
      state.email = "";
      state.userRole = "";
      state.alias = "";
      state.isAdmin = "";
      state.otherRole = "";
      state.jobZb = "";
      state.jobName = "";
      state.isPC="";
      localStorage.clear();
    },
    changRankType(state, changType: string) {
      state.rankType = changType;
    }
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage
    })
  ],
})
